import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import {
  getTiposDeDocumento,
  saveTiposDeDocumento,
  saveCiudades,
  getCiudades,
  getDepartamentos,
  saveDepartamentos,
} from 'src/app/store/actions/maestros.action';

import { RenameKeyService } from '@segurosvoluntarios_vel/commons-services';
import { Maestro } from 'src/app/pago/models/Maestro.model';
import { CiudadDTO } from 'src/app/pago/dtos/CiudadDTO.model';
import { MAPS_KEY_NORMALIZE_CIUDAD } from 'src/app/pago/const/MapsKeyNormalizeCiudad.const';
import { DepartamentoDTO } from 'src/app/pago/dtos/DepartamentoDTO.model';
import { MAPS_KEY_NORMALIZE_DEPARTAMENTO } from 'src/app/pago/const/MapsKeyNormalizeDepartamento.const';
import { MaestrosService } from 'src/app/pago/services/maestros/maestros.service';

@Injectable()
export class MaestrosEffect {
  constructor(
    private actions$: Actions,
    private maestrosService: MaestrosService
  ) {}

  getTiposDeDocumento$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(getTiposDeDocumento),
      mergeMap(() => {
        return this.maestrosService.getTiposDeDocumento().pipe(
          map((tiposDeDocumento: Maestro[]) => {
            return saveTiposDeDocumento({
              tiposDeDocumento,
            });
          })
        );
      })
    )
  );

  getCiudades$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(getCiudades),
      mergeMap(() => {
        return this.maestrosService.getCiudades().pipe(
          map((responseCiudad: CiudadDTO[]) => {
            return saveCiudades({
              ciudades: RenameKeyService.replaceKeyByMap(
                MAPS_KEY_NORMALIZE_CIUDAD,
                responseCiudad
              ),
            });
          })
        );
      })
    )
  );

  getDepartamentos$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(getDepartamentos),
      mergeMap(() => {
        return this.maestrosService.getDepartamentos().pipe(
          map((responseDepartamento: DepartamentoDTO[]) => {
            return saveDepartamentos({
              departamentos: RenameKeyService.replaceKeyByMap(
                MAPS_KEY_NORMALIZE_DEPARTAMENTO,
                responseDepartamento
              ),
            });
          })
        );
      })
    )
  );
}
